import {Component, Input, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {displayImg} from "../utils/utils.functions";

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent implements OnInit {
  @Input() text : string | undefined = "User Name"
  @Input() email : string = ""
  @Input() phoneNumber : string = ""
  @Input() imageSrc : string | null | undefined = null
  @Input() withRating : boolean = false
  @Input() data: any;
  @Input() small = false;
  @Input() column: any; // Define input property for 'column'

  rating(rate: number) {
  }

  ngOnInit(): void {
    
  }
  protected readonly environment = environment;
  protected readonly displayImg = displayImg;
}
